
import React, { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PreloadLink from "../navigation/PreloadLink";
import { servicesData } from "../../data/servicesData";

const ServicesGrid = () => {
  useEffect(() => {
    const preloadServiceImages = () => {
      servicesData.forEach(service => {
        const img = new Image();
        img.src = service.imageSrc;
        console.info(`Image loaded: ${service.imageSrc}`);
      });
    };
    
    setTimeout(preloadServiceImages, 300);
  }, []);

  return (
    <section className="bg-gray-100 flex-grow py-16 pt-16">
      <div className="container max-w-5xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-800 mb-2 text-center">USA Traffic Control Services</h2>
        <p className="text-center text-gray-600 mb-8">Click below to learn more about our services and capabilities.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {servicesData.map((service) => {
            const isFirstCard =
              service.id === "traffic-control" &&
              service.title === "Temporary Traffic Control";
            return (
              <PreloadLink
                key={service.id}
                to={`/services#${service.id}`}
                className="block transform transition-transform hover:scale-105"
                preloadImages={[service.imageSrc]}
              >
                <Card
                  className={`border-none bg-white hover:shadow-lg transition-shadow h-full overflow-hidden`}
                  style={
                    isFirstCard
                      ? {
                          minWidth: 0,
                          // Allow the card to be slightly wider ONLY for first card
                          maxWidth: "108%",
                        }
                      : undefined
                  }
                >
                  <div className="h-48 w-full overflow-hidden">
                    <img
                      src={service.imageSrc}
                      alt={service.title}
                      className="w-full h-full object-cover"
                      loading="eager"
                    />
                  </div>
                  <CardHeader className="p-6 pb-[16px]">
                    <CardTitle
                      className="text-gray-800 text-left"
                      style={
                        isFirstCard
                          ? {
                              // Optimized to be just past the width of description
                              fontSize: "1.41rem", // Large but not jarring
                              fontWeight: 700,
                              letterSpacing: "-0.023em",
                              lineHeight: 1.11,
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                              paddingRight: "4px",
                            }
                          : undefined
                      }
                    >
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent
                    className="px-6 pt-0 pb-4 mt-0 text-gray-600 text-left whitespace-pre-line"
                    style={{ fontSize: "1rem" }}
                  >
                    {service.description.map((line, idx) => (
                      <React.Fragment key={idx}>
                        {line}
                        {idx < service.description.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </CardContent>
                </Card>
              </PreloadLink>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
